import { DashboardSnapshot } from '@ddv/models';

export class DashboardGroup {
    id: string | number;
    name: string;
    isDefault?: boolean;
    dashboards: DashboardSnapshot[];

    // [GROUPS] deprecated - delete when we no longer support groups from mw
    /** @deprecated */
    sortOrder: number;

    constructor(init?: Partial<DashboardGroup | DashboardGroupFromAwsApi>) {
        this.id = init?.id ?? 0;
        this.name = init?.name ?? '';
        this.isDefault = init?.isDefault;

        this.dashboards = init?.dashboards ?
            init.dashboards.map((dashboard) => {
                const dashboardIsObject = typeof dashboard === 'object';
                return new DashboardSnapshot(dashboardIsObject ? dashboard : ({ id: dashboard } as DashboardSnapshot));
            }) :
            [];

        this.sortOrder = -1;
    }
}

export interface DashboardGroupFromAwsApi extends Omit<DashboardGroup, 'dashboards' | 'sortOrder'> {
    dashboards: (string | number)[];
}
